import gameIframe from '@ps/bridge/iframe/iframe'
import { pickFontAndText } from '@com/i18n'
import _ from 'lodash'
import { getDescendantsText } from '@ps/bridge/qc/node/utils'
import { fetchFont, getFontList } from '@ps/bridge/resource/font'
import { setEnableShadowAfterSetFont } from '@ps/bridge/qc/node/text'

function setTextNodesFont() {
  const textNodes = getDescendantsText(gameIframe.UIRoot)
  textNodes.forEach(node => {
    // 重新设置 font，如果不重新设置，字体切换不生效。重新设置后会重新渲染
    // eslint-disable-next-line no-self-assign
    node.font = node.font
    setEnableShadowAfterSetFont(node)
  })
}

/**
 * @param pid
 * @param fontList 仓库字体列表，用于过滤 languages.json 中的字体，如果不是字体库的中字体就不请求
 */
export async function loadFontListWhenGameReady({ pid, fontList }: { pid: number, fontList: string[] }) {
  const fontLoader = gameIframe.fontLoader
  if (!fontLoader || typeof fontLoader.fetch !== 'function') {
    throw new Error('fontLoader is not ready')
  }

  if (!gameIframe.languagesMgr) {
    throw new Error('languagesMgr is not ready')
  }
  const languagesRes = gameIframe.languagesMgr.getRes()
  // 读取字体时，保证请求的字体在资源库中有
  const fonts = (pickFontAndText(languagesRes.languages) || []).filter(item => fontList.includes(item.name))

  console.log('fonts ============', fonts)
  if (!_.isEmpty(fonts)) {
    const newFontList = await getFontList({ fonts, pid })
    const data = await fetchFont(newFontList)
    // 设置字体，保证加载后的字体生效
    setTextNodesFont()
    return data
  }
}
